import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  ADD_PLATFORM_CONFIG,
  PING_ENDPOINT,
  UPDATE_PLATFORM,
} from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import EchoAlert from "../EchoAlert";
import "./Modal.css";

const AddPlatformModal = (props) => {
  const { editData } = props;
  const [circularProgress, displayCircularProgress] = React.useState(false);
  const [name, setName] = React.useState("");
  const [ip, setIP] = React.useState("");
  const [datasetID, setDatasetID] = React.useState("");
  const [rpcURL, setRpcURL] = React.useState("");
  const [platformUID, setPlatformUID] = React.useState("");
  const [platformPass, setPlatformPass] = React.useState("");
  const [anon, setAnon] = React.useState(false);
  const [error, seterror] = useState(false);
  const [id, setId] = React.useState("");
  const [pingIP, setpingIP] = useState("");
  const [pingstatus, setPingStatus] = useState("");
  const [echoAlert, setEchoAlert] = useState(false);
  const [errorforpingstatus, seterrorforpingstatus] = useState(false);

  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setDatasetID(editData.dataset_id);
      setAnon(editData.anon);
      setId(editData.id);
      setIP(editData.ip);
      setRpcURL(editData.rpc_url);
      setPlatformUID(editData.platform_user_id);
    }
  }, [editData, pingstatus]);

  useEffect(() => {
    if (circularProgress && pingstatus == "") {
      displayCircularProgress(true);
    } else {
      displayCircularProgress(false);
    }
  }, [pingstatus, circularProgress]);

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const handleSubmit = async (e) => {
    if (
      !name ||
      !ip ||
      !datasetID ||
      !platformUID ||
      !platformPass ||
      !rpcURL
    ) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    // if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
    //   // IP is not a valid IP address (IPv4)
    //   setIP('')
    //   seterror(true);
    //   setTimeout(() => {
    //     seterror(false);
    //   }, 2000);
    //   return;
    // }

    if (!/^\d+$/.test(datasetID)) {
      // Port is not a valid number
      setDatasetID("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      try {
        const response = await axiosInstance.post(
          `${ADD_PLATFORM_CONFIG}`,
          {
            name: name,
            ip: ip,
            dataset_id: datasetID,
            platform_user_id: platformUID,
            platform_password: platformPass,
            rpc_url: rpcURL,
            anon: false,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          setName("");
          setAnon("");
          setDatasetID("");
          setIP("");
          setPlatformUID("");
          setPlatformPass("");
          setRpcURL("");
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const handleEditSubmit = async (e) => {
    if (
      !name ||
      !ip ||
      !datasetID ||
      !platformUID ||
      !platformPass ||
      !rpcURL
    ) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    // if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
    //   // IP is not a valid IP address (IPv4)
    //   setIP('')
    //   seterror(true);
    //   setTimeout(() => {
    //     seterror(false);
    //   }, 2000);
    //   return;
    // }

    if (!/^\d+$/.test(datasetID)) {
      // Port is not a valid number
      setDatasetID("");
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      try {
        const response = await axiosInstance.put(
          `${UPDATE_PLATFORM}`,
          {
            id: id,
            name: name,
            ip: ip,
            dataset_id: datasetID,
            platform_user_id: platformUID,
            platform_password: platformPass,
            anon: false,
            rpc_url: rpcURL,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const checkpingstatus = async () => {
    if (pingIP == "") {
      return;
    } else
      try {
        displayCircularProgress(true);
        const response = await axiosInstance.post(
          `${PING_ENDPOINT}`,
          {
            url: pingIP,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setPingStatus(response.data.message);
        seterrorforpingstatus(true);
        setEchoAlert(true);
        setTimeout(() => {
          seterrorforpingstatus(false);
        }, 2000);
      } catch (error) {
        setPingStatus("Invalid Input");
        setEchoAlert(true);
        seterrorforpingstatus(true);
        setTimeout(() => {
          seterrorforpingstatus(false);
        }, 2000);
      }
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={props.ModalState}
        onClose={props.handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="h5 font-weight-bold  mt-2">Platform</div>
            <IconButton
              className="text-light"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="my-4 rounded">
            <div className="sort_search_header_field">Name*</div>
            <div className=" mt-2">
              <input
                required
                className="text-input-modal"
                id="name"
                onChange={(e) => setName(e.target.value.trimStart())}
                value={name}
              />
              {!name && error && (
                <span className="errorStyles">NAME Required</span>
              )}
            </div>
            <div className=" mt-2">
              <div className="sort_search_header_field">Platform URL*</div>
              {!editData && (
                <input
                  className="text-input-modal"
                  style={{ width: "83%" }}
                  id="ip"
                  placeholder="ex: http://localhost:8000"
                  onChange={(e) => {
                    setIP(e.target.value.trimStart());
                    setpingIP(e.target.value.trimStart());
                  }}
                  value={ip}
                />
              )}
              {editData && (
                <input
                  className="text-input-modal"
                  id="ip"
                  placeholder="ex: http://localhost:8000"
                  onChange={(e) => {
                    setIP(e.target.value.trimStart());
                    setpingIP(e.target.value.trimStart());
                  }}
                  value={ip}
                />
              )}
              {circularProgress && (
                <CircularProgress
                  style={{
                    marginLeft: "20px",
                    height: "20px",
                    width: "20px",
                    marginTop: "0px",
                  }}
                />
              )}
              {!editData && pingIP == "" && !circularProgress && (
                <button
                  className="btn-class"
                  style={{
                    marginLeft: "2px",
                    backgroundColor: "grey",
                    marginTop: "0px",
                  }}
                  onClick={checkpingstatus}
                >
                  PING
                </button>
              )}
              {!editData && pingIP != "" && !circularProgress && (
                <button
                  className="btn-class"
                  style={{ marginLeft: "2px", marginTop: "0px" }}
                  onClick={checkpingstatus}
                >
                  Ping
                </button>
              )}
              <EchoAlert
                echoAlert={echoAlert}
                setEchoAlert={setEchoAlert}
                type="PLATFORM"
                value={pingIP}
                result={pingstatus}
                setPingStatus={setPingStatus}
              />
              {/* {errorforpingstatus && (
                <span
                  className="errorStyles"
                  style={{ color: "rgb(249, 215, 161)" }}
                >
                  {pingstatus}
                </span>
              )} */}
              {!ip && error && (
                <span className="errorStyles">URL Required</span>
              )}
            </div>
            {/* <div className=" mt-2">
              <div className="sort_search_header_field">Check IP status</div>
              <div>
                <div>
                  <input
                    className="text-input-modal"
                    style={{ width: "83%" }}
                    id="ping_ip"
                    onChange={(e) => setpingIP(e.target.value.trimStart())}
                    value={ip}
                  />
                  <button
                    className="btn-class"
                    style={{ marginLeft: "2px" }}
                    onClick={checkpingstatus}
                  >
                    check
                  </button>
                </div>
              </div>
              { errorforpingstatus && (
                <span className="errorStyles" style={{color:"rgb(249, 215, 161)"}}>{pingstatus}</span>
              )}
            </div> */}
            <div className=" mt-2">
              <div className="sort_search_header_field">RPC URL*</div>
              <input
                required
                className="text-input-modal"
                id="rpc_url"
                placeholder="ex: localhost"
                onChange={(e) => setRpcURL(e.target.value.trimStart())}
                value={rpcURL}
              />
              {!rpcURL && error && (
                <span className="errorStyles">RPC URL Required</span>
              )}
            </div>
            <div className=" mt-2">
              <div className="sort_search_header_field">Dataset ID*</div>
              <input
                required
                className="text-input-modal"
                id="datset_id"
                onChange={(e) => setDatasetID(e.target.value.trimStart())}
                value={datasetID}
              />
              {!datasetID && error && (
                <span className="errorStyles">DATASET Required</span>
              )}
            </div>
            <div className=" mt-2">
              <div className="sort_search_header_field">PLATFORM Username*</div>
              <input
                required
                className="text-input-modal"
                id="datset_id"
                onChange={(e) => setPlatformUID(e.target.value.trimStart())}
                value={platformUID}
              />
              {!platformUID && error && (
                <span className="errorStyles">USERNAME Required</span>
              )}
            </div>
            <div className=" mt-2">
              <div className="sort_search_header_field">PLATFORM Password*</div>
              <input
                required
                className="text-input-modal"
                id="datset_id"
                type="password"
                onChange={(e) => setPlatformPass(e.target.value.trimStart())}
                value={platformPass}
              />
              {!platformPass && error && (
                <span className="errorStyles">PASSWORD Required</span>
              )}
            </div>
            {/* <div className=" mt-2">
              <div className="sort_search_header_field">Anonymize</div>
              <select
                id="anon"
                value={anon}
                label="Anon"
                className="text-input-modal"
                onChange={(e) => setAnon(e.target.value.trimStart())}
              >
                <option value={"select"}>Select</option>
                <option value={true}>True</option>
                <option value={false}>False</option>
              </select>
              {(anon == "" || anon == "select") && error && (
                <span className="errorStyles">ANON Required</span>
              )}
            </div> */}
            <div className="text-center mt-2">
              <button
                type="submit"
                className="btn-class"
                onClick={editData ? handleEditSubmit : handleSubmit}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default AddPlatformModal;
